module.exports = __webpack_public_path__ + "static/ConcishareGrocery-f667782b418a947e0273bf04acb5cad0.png";